import React, { useEffect, useState } from "react";
import icons from "../../icons.config";
import { fetchSizeGuide } from "../../Providers/contactUsProvider";
import { IMAGE_URL } from "../../api-urls";
import Lottie from "lottie-react";
import loadingAnimation from '../../Assets/loadingAnimation.json';

const SizeGuide = ({ isOpen, togglePopup, showTrigger = true }) => {
  const [sizeGuideData, setSizeGuideData] = useState({
    title: "",
    description: "",
    images: [],
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchGuide = async () => {
      if (isOpen) {
        setLoading(true); // Start loading
        try {
          console.log("Fetching Size Guide...");
          const response = await fetchSizeGuide();

          if (response?.sizeGuide?.length > 0) {
            const guide = response.sizeGuide[0]; // Assuming only one guide is returned
            setSizeGuideData({
              title: guide.title || "Size Guide",
              description: guide.description || "",
              images: guide.images || [],
            });
          }
        } catch (error) {
          console.error("Error fetching size guide:", error);
        }
        setLoading(false); // Stop loading
      }
    };

    fetchGuide();
  }, [isOpen]);

  return (
    <>
      {/* Conditionally Show Trigger Button */}
      {showTrigger && (
        <h3
          className="text-sm font-normal font-outfit mb-4 text-hcolor underline cursor-pointer"
          onClick={togglePopup}
        >
          SIZE GUIDE
        </h3>
      )}

      {/* Popup */}
      {isOpen && (
        <div className="fixed inset-0 top-28 z-30 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-tertiary px-6 pb-10 w-4/5 lg:w-[55%] rounded-lg justify-center lg:h-[93%] overflow-y-auto">
            {/* Close Button */}
            <div className="flex justify-end relative top-8">
              <button className="text-xl text-gray-600" onClick={togglePopup}>
                <img src={icons.close} alt="close icon" />
              </button>
            </div>

            {/* Popup Content */}
            <h3 className="text-2xl font-outfit font-normal mb-6 flex justify-center text-primary1">
              {sizeGuideData.title}
            </h3>
            <hr className="mb-4 text-secondary" />

            {/* Loading State */}
            {loading ? (
              <div className="flex justify-center items-center h-[400px]">
              <Lottie animationData={loadingAnimation} loop={true} className="w-[200px] h-[200px]" />
            </div>
            ) : (
              <>
                <p className="text-base mb-4 text-center font-poppins font-light my-4">
                  {sizeGuideData.description}
                </p>

                {/* Size Chart Images */}
                <div className="lg:px-4 flex flex-col items-center gap-4">
                  {sizeGuideData.images.length > 0 ? (
                    sizeGuideData.images.map((image, index) => (
                      <img
                        key={index}
                        src={IMAGE_URL + image}
                        alt={`Size chart ${index + 1}`}
                        className="w-full h-auto"
                      />
                    ))
                  ) : (
                    <p className="text-center text-gray-500">Size chart not available</p>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default SizeGuide;
